// eslint-disable-next-line
import util from 'util';

import React, { Component } from 'react';
import { connect } from 'react-redux';
import AddIcon from '@material-ui/icons/AddCircleOutlined';
// import PersonIcon from '@material-ui/icons/Person';

// eslint-disable-next-line
import * as MuiCore from '@material-ui/core';
import MuiAlert from '@material-ui/lab/Alert';
import { withStyles } from '@material-ui/core/styles';

import * as ServiceIcons from './Icons';
import * as Formatters from '../ui/Formatters';

import * as coreSelectors from '../core/selectors';
import * as serviceSelectors from './selectors';
import * as serviceActions from './actions';
import LinkedText from '../ui/LinkedText';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import SearchInput from 'ui/SearchInput';


const styles = theme => ({
  /* Raised box around the content */
  contentBox : {
    width: '100%',
    height: '100%',
    borderRadius: 20,
    padding: 0,
    display: 'flex',
  },
  
  /* Scrolled area inset from the content box */
  contentScroller : {
    overflow: 'auto',
    width: '100%',
  },

  /* Top control area with search box and add content */
  controlPanel : {
    display: 'flex',    
    alignItems: 'center',
  },
  

  /* Contact list container */
  contactList : {
    marginRight: 20,
  },

  /* Contact row */
  contactRow: {
    display: 'flex',
    marginRight: 30,
  },

  /* Left side icon */
  peopleIcon : {
    marginLeft: 20,
    display: 'flex',
    alignItems: 'center',
  },

  /* Clickable center area with contact name */
  infoBlock : {
    flexGrow: '1',
    paddingLeft: 10,
    '&:hover' : {
      background: theme.palette.grey[200],
    },
  },

  /* Top name line in the info block */
  name: {
    ...theme.typography.body1,
    fontWeight: 'bold',
  },
  /* Bottom business name line in the info block */
  business: {
    ...theme.typography.body1,
    color: theme.palette.primary.main,
  },
  

  /* Right side menu */
  menuBlock : {
    display: 'flex',
    alignItems: 'center',
  },

  /* Section row at the start of each letter */
  sectionRow: {
    marginLeft: 20,
    marginRight: 20,
    marginTop: 20,   
    ...theme.typography.body2,
    fontWeight: 'bold',
  },

  oddRow: {
    fontFamily: 'Sofia'
  },

  evenRow: {
    backgroundColor: '#fcf9f2',
    fontFamily: 'Sofia'
  },
  tableHeader:{
    backgroundColor:'#a9a1b6'
  },
  tableHeaderCell:{
    color:'white',
    fontFamily: 'Sofia-bold'
  }
});

// const StyledTableRow =() => ({
//   root: {
//     '&:nth-of-type(odd)': {
//       backgroundColor: 'yellow',
//     },
//   },
// })(MuiCore.TableRow);
/*
 * Default filler screen until the real one is implemented
 */

class Contacts extends Component {
  state = {
    contactMenuOpen : false,
    contactMenuElement : null,
    menuContact : {},
    confirmDelete : false,
    sortDirection: null,
    sortColumn: null
  }

  componentDidMount(){
    document.title = 'Ruby - Contacts';
  }

  openMenu = (event, contact) => {
    this.setState({contactMenuElement : event.currentTarget,
                   contactMenuOpen : true,
                   menuContact : contact });
  }

  deleteContact = () => {
    this.setState({confirmDelete: false});
    this.props.deleteContact(this.state.menuContact.contactId);
  }

  changeSearch = (contactsSearchText) => {
    this.props.setContactsSearchText(contactsSearchText);
  }

  checkPhoneNumbers = () => {
    return this.props.user.patchNumbers > 0;
  }

  setSortColumn = (key) => {
    if(this.state.sortColumn === key){
      this.changeSortOrder();
    } else {
      this.setState({sortColumn: key, sortDirection: 'asc'});
    }
  }

  changeSortOrder = () => {
    if(this.state.sortDirection === null){
      this.setState({sortDirection: 'asc'})
    } else if(this.state.sortDirection === 'asc') {
      this.setState({sortDirection: 'desc'})
    } else {
      this.setState({sortDirection: null})
    }
  }

  render() {
    const { classes, user, openContact, newContact,
            addContactLink, setAddContactLink } = this.props;

    let contacts = user.contacts;

    contacts.forEach((contact, i) => {
      contact.contactMethods.filter(method => method.contactMethodType === 'PHONE').forEach(item => {
        if(item.phoneNumber){
          contacts[i].phoneNumbers = item.phoneNumber + ",";
        }
      })
      contact.contactMethods.filter(method => method.contactMethodType === 'EMAIL').forEach(item => {
        if(item.email){
          contacts[i].emails = item.email + ",";
        }
      })  
    })

    /* Filter by the search term if set */
    let searchText = this.props.contactsSearchText.trim().toUpperCase();
    let phoneSearch = searchText.replace(/[()-\s]/g, '');
    let filtered;
    if (searchText.length > 0) {
      filtered = contacts.filter(contact => {
        if (contact.displayName.toUpperCase().includes(searchText)) {
          return(true);
        }
        if (contact.business && contact.business.toUpperCase().includes(searchText)) {
          return(true);
        }
        let numberMatches = contact.contactMethods.filter(method =>
          method.phoneNumber && method.phoneNumber.includes(phoneSearch)).length;
        let emailMatches = contact.contactMethods.filter(method =>
          method.email && method.email.toUpperCase().includes(searchText)).length;
        let addressMatches = contact.contactMethods.filter(method =>
          method.address && method.address.toUpperCase().includes(searchText)).length;
        
        return(numberMatches > 0 || emailMatches > 0 || addressMatches > 0);
      });
    } else {
      filtered = [ ...contacts];
    }
    /* Sort the filtered list */
    filtered.sort((a, b) => {
      if (a.displayName.toUpperCase() < b.displayName.toUpperCase()) {
        return(-1);
      }
      if (a.displayName.toUpperCase() === b.displayName.toUpperCase()) {
        return(0);
      }
      return(1);
    });
    // let header='';

    if (this.state.sortDirection != null && this.state.sortColumn !== null) {
      filtered.sort((a, b) => {
        const columnA = a[this.state.sortColumn];
        const columnB = b[this.state.sortColumn];
    
        if (columnA === columnB) {
          return 0; 
        }
    
        if (columnA === undefined) {
          return this.state.sortDirection === 'asc' ? 1 : -1; 
        }
        if (columnB === undefined) {
          return this.state.sortDirection === 'asc' ? -1 : 1; 
        }
    
        const valueA = columnA.toUpperCase();
        const valueB = columnB.toUpperCase();
    
        if (valueA < valueB) {
          return this.state.sortDirection === 'asc' ? -1 : 1;
        }
        if (valueA > valueB) {
          return this.state.sortDirection === 'asc' ? 1 : -1;
        }
        return 0;
      });
    }
      
    
    return (
      <React.Fragment>
        <MuiCore.Menu anchorEl={this.state.contactMenuElement}
                      onClose={() => this.setState({contactMenuOpen: false})}
                      transformOrigin={{
                        horizontal : 'right',
                        vertical: 'top',
                      }}
                      open={this.state.contactMenuOpen}>
          <MuiCore.MenuItem onClick={() => this.setState({confirmDelete : true, contactMenuOpen: false})}>
            Delete Contact
          </MuiCore.MenuItem>
        </MuiCore.Menu>
        
        <MuiCore.Dialog open={this.state.confirmDelete}
                        onClose={() => this.setState({confirmDelete: false })}>
          <MuiCore.DialogTitle>
            <span style={{fontFamily: 'Sofia-bold'}}>Delete Contact</span>
          </MuiCore.DialogTitle>
          <MuiCore.DialogContent>
            <MuiCore.DialogContentText>
              Are you sure you want to delete contact "{this.state.menuContact.displayName}"?
            </MuiCore.DialogContentText>
          </MuiCore.DialogContent>
          <MuiCore.DialogActions style={{ paddingLeft: 20, paddingRight: 20 }}>
            <MuiCore.Button onClick={this.deleteContact}>
              Delete
            </MuiCore.Button>
            <MuiCore.Button onClick={() => this.setState({confirmDelete: false})}>
              Cancel
            </MuiCore.Button>
          </MuiCore.DialogActions>
        </MuiCore.Dialog>
        
        <div className={classes.contentBox}>
          <div className={classes.contentScroller}>
            <div className={classes.controlPanel}>
              <SearchInput
                value={this.props.contactsSearchText}
                onChange={(event) => this.changeSearch(event.target.value)}
                onCloseIconClick={()=> this.changeSearch('')}
              />
              <div style={{flexGrow: 1}}>
              </div>
              <MuiCore.IconButton onClick={() => newContact()} style={{marginRight:20}}>
                <AddIcon fontSize='small' style={{color: '#7F2062', marginRight: 5}}/>
                <MuiCore.Typography style={{fontFamily: 'Sofia-bold', fontSize: 14, color: '#09122B'}}>Add Contact</MuiCore.Typography>
              </MuiCore.IconButton>
            </div>
            <MuiCore.Hidden xlDown={!addContactLink}>
              <MuiAlert severity="info" onClose={() => setAddContactLink(undefined)}>Select a contact to add <strong>{addContactLink && addContactLink.value}.</strong></MuiAlert>
            </MuiCore.Hidden>
            <div className={classes.contactList}>
              {/* {filtered.map(contact => {
                let currentHeader = contact.displayName.substring(0,1).toUpperCase();
                let returnValue=[];
                if (header !== currentHeader) {
                  let count = contacts.filter(c => c.displayName.substring(0,1)
                                                    .toUpperCase() === currentHeader).length;
                  returnValue.push(<div key={'h' + contact.contactId} className={classes.sectionRow}>
                    {currentHeader} ({count})<MuiCore.Divider/>
                  </div>);
                  header = currentHeader;
                }
                returnValue.push(
                  <div key={contact.contactId}
                       className={classes.contactRow}>
                    <div className={classes.peopleIcon}>
                      <PersonIcon color='primary' fontSize='large'/>
                    </div>
                    <div className={classes.infoBlock}
                         onClick={() => openContact(contact)}>
                      <div className={classes.name}>
                        {contact.displayName}
                      </div>
                      <div className={classes.business}>
                        {contact.business}
                      </div>
                    </div>
                    <div className={classes.menuBlock}>
                      <MuiCore.IconButton
                        onClick={(event) => this.openMenu(event, contact)}>
                        <ServiceIcons.MenuIcon/>
                      </MuiCore.IconButton>
                    </div>
                  </div>);
                return(returnValue);
              })} */}
              <MuiCore.TableContainer component={MuiCore.Paper}>
                <MuiCore.Table sx={{minWidth: 700}}>
                  <MuiCore.TableHead>
                    <MuiCore.TableRow className={classes.tableHeader}>
                      <MuiCore.TableCell className={classes.tableHeaderCell} onClick={() => this.setSortColumn('displayName')}>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <span style={{ marginRight: '5px', cursor: 'pointer' }}>Name</span>
                          {this.state.sortColumn === 'displayName' && this.state.sortDirection === 'asc' && <ArrowDropDownIcon />}
                          {this.state.sortColumn === 'displayName' && this.state.sortDirection === 'desc' && <ArrowDropUpIcon />}
                        </div>
                      </MuiCore.TableCell>
                      <MuiCore.TableCell className={classes.tableHeaderCell} onClick={() => this.setSortColumn('business')}>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <span style={{ marginRight: '5px', cursor: 'pointer' }}>Company</span>
                          {this.state.sortColumn === 'business' && this.state.sortDirection === 'asc' && <ArrowDropDownIcon />}
                          {this.state.sortColumn === 'business' && this.state.sortDirection === 'desc' && <ArrowDropUpIcon />}
                        </div>
                      </MuiCore.TableCell>
                      <MuiCore.TableCell className={classes.tableHeaderCell} onClick={() => this.setSortColumn('phoneNumbers')}>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <span style={{ marginRight: '5px', cursor: 'pointer' }}>Phone</span>
                          {this.state.sortColumn === 'phoneNumbers' && this.state.sortDirection === 'asc' && <ArrowDropDownIcon />}
                          {this.state.sortColumn === 'phoneNumbers' && this.state.sortDirection === 'desc' && <ArrowDropUpIcon />}
                        </div>
                      </MuiCore.TableCell>
                      <MuiCore.TableCell className={classes.tableHeaderCell} onClick={() => this.setSortColumn('emails')}>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <span style={{ marginRight: '5px', cursor: 'pointer' }}>Email</span>
                          {this.state.sortColumn === 'emails' && this.state.sortDirection === 'asc' && <ArrowDropDownIcon />}
                          {this.state.sortColumn === 'emails' && this.state.sortDirection === 'desc' && <ArrowDropUpIcon />}
                        </div>
                      </MuiCore.TableCell>
                      <MuiCore.TableCell className={classes.tableHeaderCell}></MuiCore.TableCell>
                    </MuiCore.TableRow>
                  </MuiCore.TableHead>
                  <MuiCore.TableBody>
                    {filtered.map((contact, index) => {

                      return(
                        <MuiCore.TableRow 
                          key={index}
                          hover
                          onClick={()=>openContact(contact)}
                          className={index%2 === 0 ? classes.evenRow : classes.oddRow}
                        >
                          <MuiCore.TableCell component="th" scope="row">{contact.displayName}</MuiCore.TableCell>
                          <MuiCore.TableCell>{contact.business}</MuiCore.TableCell>
                          <MuiCore.TableCell>{(contact.contactMethods || [])
                                              .filter(method=>method.contactMethodType==='PHONE')
                                              .map(item => 
                                                <div>
                                                  {this.checkPhoneNumbers() ? <LinkedText value={Formatters.formatPhoneNumber(item.phoneNumber)} onClick={this.props.openContactLink}/> : Formatters.formatPhoneNumber(item.phoneNumber)}
                                                  {item.phoneExtension !== undefined ? ` ext. ${item.phoneExtension}` : ''}
                                                </div>
                                              )}</MuiCore.TableCell>
                          <MuiCore.TableCell>{(contact.contactMethods || [])
                                              .filter(method=>method.contactMethodType==='EMAIL')
                                              .map(item => 
                                                <div>
                                                  <LinkedText value={item.email} onClick={this.props.openContactLink}/>
                                                </div>
                                              )}</MuiCore.TableCell>
                          <MuiCore.TableCell align='right'>
                            <div className={classes.menuBlock}>
                              <MuiCore.IconButton
                                size='small'
                                onClick={(event) => {
                                  this.openMenu(event, contact);
                                  event.stopPropagation();
                                }}>
                                <ServiceIcons.MenuIcon/>
                              </MuiCore.IconButton>
                            </div>
                          </MuiCore.TableCell>
                        </MuiCore.TableRow>
                    )})}
                  </MuiCore.TableBody>
                </MuiCore.Table>
              </MuiCore.TableContainer>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return ({
    user : coreSelectors.getUser(state),
    contactsSearchText: serviceSelectors.getContactsSearchText(state),
    addContactLink : serviceSelectors.getAddContactLink(state),
  });
};

const mapDispatchToProps = {
  openContact : serviceActions.openContact,
  newContact : serviceActions.newContact,
  deleteContact : serviceActions.deleteContact,
  setContactsSearchText : serviceActions.setContactsSearchText,
  setAddContactLink : serviceActions.setAddContactLink,
  openContactLink : serviceActions.openContactLink,
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(Contacts));

